import {FilterProvider} from 'plugins/modules/filter/provider/new';
import React, {FC, ReactNode, useMemo} from 'react';
import {useLazyGetCatalogQuery} from 'modules/products/services';
import {TGetListingRequest} from 'plugins/modules/listing/api/api';
import {IProductShort} from 'modules/products/types';
import {TGetListingTransformedResponse} from 'plugins/modules/listing/types';
import {ListingProvider} from 'plugins/modules/listing/provider';
import {SORT_LIST} from 'modules/products/constants';
import {useExpressOrderStoreId} from 'modules/express-order/hooks/useExpressOrderStoreId';

interface IProps {
    children: ReactNode;
    initialData: TGetListingTransformedResponse<IProductShort>;
    initialArgs: TGetListingRequest;
}

export const CatalogPageProvider: FC<IProps> = ({children, initialArgs, initialData}) => {
    const expressOrderStoreId = useExpressOrderStoreId(initialArgs.expressOrderStoreId);

    const dynamicQueryArgs = useMemo(() => ({expressOrderStoreId}), [expressOrderStoreId]);

    return (
        <ListingProvider
            initialData={initialData}
            initialArgs={initialArgs}
            sortList={SORT_LIST}
            pageType={'PLP'}
            lazyQuery={useLazyGetCatalogQuery}
            dynamicQueryArgs={dynamicQueryArgs}
        >
            <FilterProvider>{children}</FilterProvider>
        </ListingProvider>
    );
};
